/* eslint-disable no-constant-condition */
import styled from "styled-components";
import { useIsDesktop } from "../../../hooks/useMediaQuery.js";
import { useTranslate } from "../../../contexts/languageContext";
import { responsive } from "../../../resources/constantes.json";
import React from "react";
import { useNomenclator } from "../../../contexts/nomenclatorContext.js";

const LeyendaCamaras = ({data, idEleccion, title}) => {
  const isDesktop = useIsDesktop();
  const nomenclator = useNomenclator();
  const listaCamaras = parseCamaras(data, nomenclator, idEleccion);
  return (
    <LeyendaContainer>
       {title && (
         <TitleLeyenda>{title}</TitleLeyenda>
       )}
      <ListadoCamaras>
        {listaCamaras.map(_item => (
          <CamaraElement>
            <>
              <CamaraColor color={_item.color}/>
              <CamaraName>{_item.name}</CamaraName>
            </>
          </CamaraElement>
        ))}
      </ListadoCamaras>
    </LeyendaContainer>
  );
};

const parseCamaras = (unParsedData, nomen, idEleccion) =>{
  const parseData = [];
  unParsedData.camaras.map(c => c.cam).forEach(cam =>{
    parseData.push({
      color: nomen.nomAmbitos[idEleccion].cam[cam]['co'],
      name: nomen.nomAmbitos[idEleccion].cam[cam]['ca']
    });
  })
  return parseData;
}

const LeyendaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TitleLeyenda = styled.h2`
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  margin: 1rem;
`;

const ListadoCamaras = styled.ul`
  display: flex;
  width: 100;
  justify-content:space-around;
  flex: 1 1 0;
  flex-direction: row;
`;

const CamaraElement = styled.li`
  font-size: 12px;
  margin-left: 4px;
  float: left;
  display:flex;
`;

const CamaraColor = styled.span`
  height: 23px;
  width: 5px;
  border-radius: 5px;
  margin-right: 5px;
  background-color: ${({ color }) => color};
`;

const CamaraName = styled.span`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
`;


const SLeyendaCamaras = styled(LeyendaCamaras)`
  width: 100%;
  font-size: 12px;
  margin-bottom: 30px;
  color: #2f435f;
`;

export default SLeyendaCamaras;
